/* "Design your own" entry points: header/mobile menus, footer links, product card under Buy now, collection-page link strip. */
(function () {
  if (window.__bbDyo) return; window.__bbDyo = true;
  var URL_DYO = '/pages/design-your-own';
  function cloneBefore(li, href, label, badge) {
    var c = li.cloneNode(true);
    c.classList.add('bb-nav-dyo'); c.classList.remove('active', 'current');
    var ca = c.querySelector('a'); ca.setAttribute('href', href); ca.removeAttribute('target');
    var txtEl = Array.prototype.filter.call(ca.querySelectorAll('*'), function (n) { return /contact us/i.test(n.textContent) && !n.children.length; })[0] || ca;
    txtEl.textContent = label;
    if (badge) { var b = document.createElement('em'); b.className = 'bb-nav-dyo__new'; b.textContent = 'NEW'; txtEl.appendChild(b); }
    li.parentNode.insertBefore(c, li);
  }
  function menus() {
    document.querySelectorAll('ul').forEach(function (ul) {
      if (ul.querySelector('.bb-nav-dyo')) return;
      var a = Array.prototype.filter.call(ul.querySelectorAll(':scope > li > a, :scope > li > div > a'), function (x) { return /contact us/i.test(x.textContent); })[0];
      if (!a) return;
      var li = a.closest('li');
      if (ul.closest('footer')) {
        cloneBefore(li, URL_DYO + '?piece=tee', 'Design your own tee', false);
        cloneBefore(li, URL_DYO + '?piece=hoodie', 'Design your own hoodie', false);
      } else {
        cloneBefore(li, URL_DYO, 'Design your own', true);
      }
    });
  }
  function pdp() {
    if (!/\/products\//.test(location.pathname) || document.querySelector('.bb-dyo-pdp')) return;
    var anchor = document.querySelector('#gokwik-buy-now'); anchor = anchor && (anchor.closest('buy-now') || anchor.closest('.group-button-buyitnow'));
    if (!anchor) return;
    var t = (document.title || '').toLowerCase();
    var piece = /hoodie|jacket/.test(t) ? 'hoodie' : /sweatshirt/.test(t) ? 'sweatshirt' : 'tee';
    var a = document.createElement('a');
    a.className = 'bb-dyo-pdp'; a.href = URL_DYO + '?piece=' + piece;
    a.innerHTML = '<i aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg></i><span><b>Want your own design?</b>Design your own ' + piece + ' · free mockup first</span><em aria-hidden="true">→</em>';
    anchor.parentNode.insertBefore(a, anchor.nextSibling);
  }
  function collection() {
    if (!/\/collections\//.test(location.pathname) || /\/products\//.test(location.pathname) || document.querySelector('.bb-dyo-coll')) return;
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    var d = document.createElement('div');
    d.className = 'bb-dyo-coll';
    d.innerHTML = '<span>Didn’t find what you want? We’ll stitch your idea.</span><a href="' + URL_DYO + '?piece=tee">Design your own tee ›</a><a href="' + URL_DYO + '?piece=hoodie">Design your own hoodie ›</a>';
    main.appendChild(d);
  }
  function style() {
    if (document.getElementById('bb-dyo-css')) return;
    var st = document.createElement('style'); st.id = 'bb-dyo-css';
    st.textContent = '.bb-nav-dyo__new{display:inline-block;margin-left:6px;padding:2px 5px;border-radius:4px;background:#121110;color:#F2C14E;font:800 9px/1.2 Inter,system-ui,sans-serif;letter-spacing:.5px;font-style:normal;vertical-align:middle}' +
      '.bb-dyo-pdp{display:flex;align-items:center;gap:10px;margin:12px 0 4px;padding:10px 12px;border:1.5px dashed #B8860B;border-radius:12px;background:#FBF4E2;color:#121110!important;text-decoration:none!important;font-family:Inter,system-ui,sans-serif;font-size:13px;line-height:1.3}' +
      '.bb-dyo-pdp i{flex-shrink:0;width:34px;height:34px;border-radius:17px;background:#121110;color:#F2C14E;display:flex;align-items:center;justify-content:center}' +
      '.bb-dyo-pdp span{flex:1;min-width:0;color:#3d3934}.bb-dyo-pdp b{display:block;font-size:14px;color:#121110}.bb-dyo-pdp em{font-style:normal;font-weight:800;font-size:18px}' +
      '.bb-dyo-coll{display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:6px 18px;margin:24px 16px 32px;padding:16px 20px;border-radius:18px;background:#f5f5f7;font:15px/1.4 Inter,system-ui,-apple-system,sans-serif;text-align:center}' +
      '.bb-dyo-coll span{color:#6e6e73;width:100%}.bb-dyo-coll a{color:#0066cc!important;font-weight:500;text-decoration:none!important;white-space:nowrap}.bb-dyo-coll a:hover{text-decoration:underline!important}' +
      '@media(min-width:750px){.bb-dyo-coll{max-width:1120px;margin:32px auto 40px}.bb-dyo-coll span{width:auto}}';
    document.head.appendChild(st);
  }
  function boot() { style(); menus(); pdp(); collection(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
})();
